import React, { useCallback, useEffect, useState } from 'react';
import { readUiSoundEnabled, subscribeUiSoundEnabled, toggleUiSoundEnabled } from '../../utils/uiSound';

/** 상단 네비바 효과음 on/off — 햄버거 메뉴 토글과 상태 공유(cp_ui_sound_enabled) */
const SoundToggleButton: React.FC = () => {
  const [on, setOn] = useState(() => readUiSoundEnabled());
  useEffect(() => subscribeUiSoundEnabled(setOn), []);
  const handleClick = useCallback(() => setOn(toggleUiSoundEnabled()), []);
  const label = on ? '효과음 끄기' : '효과음 켜기';
  return (
    <button
      type="button"
      className="cp-mail-icon-btn cp-sound-toggle-btn"
      onClick={handleClick}
      aria-label={label}
      aria-pressed={on}
      title={label}
      data-sfx="none"
    >
      <svg
        className="cp-mail-icon-btn-svg"
        viewBox="0 0 20 20"
        fill="none"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 8h3l4-3.5v11L6 12H3z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        {on ? (
          <>
            <path d="M13 7.5a3.5 3.5 0 0 1 0 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M15.5 5a7 7 0 0 1 0 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </>
        ) : (
          <>
            <path d="M13 8l4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M17 8l-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </>
        )}
      </svg>
    </button>
  );
};

export default SoundToggleButton;
